export default function (Vue) {
  Vue.directive('visible', function (el, binding) {
    const value = binding.value

    if (value) {
      el.style.visibility = 'visible'
    }
    else {
      el.style.visibility = 'hidden'
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/VueVisible.js